import React from 'react';
import { ActionBarWrapper } from 'components/wrappers/pages';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import MenuTitle from 'components/MenuTitle';
import { isFullSiteMode } from 'utils/fullSite';
import DropdownButtonSelectIcon from 'components/Fields/ReduxForm/DropdownButtonSelectIcon';
import styles from './ActionBar.css';

const EMPLOYEE_OPTIONS = [
  { id: 'active', name: 'Active Employees' },
  { id: 'inactive', name: 'Inactive Employees' },
];

class ActionBar extends React.Component {
  render() {
    const { enableExportStaff, isOwner, isTrial, isMokaposUser } = this.props;
    return (
      <div>
        <MenuTitle menuTitle="Employee Slots" />
        <div className="pull-right col-md-6 action-staff">
          {!isFullSiteMode() && (
            <button
              className="btn btn-primary"
              onClick={this._onClickExport}
              disabled={!enableExportStaff}
            >
              Export
            </button>
          )}
          {isOwner && !isTrial && isMokaposUser && (
            <button
              className={`btn btn-primary ml-10px ${
                styles['btn-invite-staff']
              }`}
              onClick={this._onClickAddStaffSlot}
              disabled={false}
            >
              Add Employee Slot
            </button>
          )}
        </div>
        <ActionBarWrapper>
          <div className={`col-xs-12 ${styles.wrapper} search-staff`}>
            <div className={styles['action-bar']}>
              <div className={styles['btn-search']}>
                <Field
                  name="keyword"
                  component={SearchBar}
                  onChange={this._onChangeKeyword}
                  additionalStyle={styles['search-bar']}
                  placeholder="Search Employees"
                />
              </div>
              <div className={styles.status}>
                <Field
                  component={DropdownButtonSelectIcon}
                  name="status"
                  options={EMPLOYEE_OPTIONS}
                  onChange={this._onChangeStatus}
                  disabled={false}
                />
              </div>
            </div>
          </div>
        </ActionBarWrapper>
      </div>
    );
  }

  _onChangeKeyword = (e, keyword) => {
    this.props.onChangeSearch({ trigger: 'keyword', keyword });
  };

  _onClickExport = () => {
    this.props.onClickExport();
  };

  _onChangeStatus = (event, status) => {
    this.props.onChangeStatus(status);
  };

  _onClickAddStaffSlot = () => {
    this.props.onClickAddStaffSlot();
  };
}

ActionBar.propTypes = {
  isOwner: PropTypes.bool,
  onChangeSearch: PropTypes.func,
  onChangeStatus: PropTypes.func,
  onClickAddStaffSlot: PropTypes.func,
  onClickExport: PropTypes.func,
  enableExportStaff: PropTypes.bool,
  isTrial: PropTypes.bool,
  isMokaposUser: PropTypes.bool,
};

const mapForm = {
  form: 'search',
};

export default reduxForm(mapForm)(ActionBar);
